import { createContext } from 'react';



import { Station } from 'lib/api/backend.schemas';


export const StationsContext = createContext([] as Station[]);